import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: true,
  },
  fonts: {
    body: `'Jura', Montserrat, sans-serif`,
    heading: `'Jura', Montserrat, sans-serif`,
  },
  styles: {
    global: {
      body: {
        bg: '#10111d',
        color: 'rgba(255,255,255,0.88)',
      },
      '#tsparticles': {
        position: 'fixed',
        inset: 0,
        zIndex: 0,
      },
      '#root > *': {
        position: 'relative',
        zIndex: 1,
      },
    },
  },
  //варианты для различных компонентов
  components: {
    Tooltip: {
      baseStyle: {
        background: 'rgba(0, 0, 0, 0.5);',
        padding: '5px',
        fontSize: '14px !important',
      },
    },

    Button: {
      baseStyle: {
        borderRadius: '8px',
        fontWeight: 700,
      },
      defaultProps: {
        colorScheme: 'purple',
      },
      variants: {
        menu_yellow: {
          border: '2px solid',
          borderColor: 'main_yellow',
          borderRadius: '0',
          background: 'transparent',
          // width: '100%',
          _hover: {
            backgroundColor: 'main_yellow',
          },
        },
        menu_red: {
          border: '2px solid',
          borderColor: 'main_red',
          borderRadius: '0',
          background: 'transparent',
          _hover: {
            backgroundColor: 'main_red',
          },
        },
      },
    },
    Table: {
      baseStyle: {
        th: {
          color: 'rgba(255,255,255,0.78)',
          borderColor: 'rgba(255,255,255,0.08)',
          letterSpacing: '0.08em',
          fontSize: '12px',
        },
        td: {
          color: 'rgba(255,255,255,0.82)',
          borderColor: 'rgba(255,255,255,0.08)',
        },
        tr: {
          borderColor: 'rgba(255,255,255,0.08)',
        },
      },
    },
    Input: {
      baseStyle: {
        field: {
          bg: 'rgba(255,255,255,0.03)',
          borderColor: 'rgba(255,255,255,0.26)',
          color: 'white',
          borderRadius: '8px',
          _placeholder: { color: 'rgba(255,255,255,0.42)' },
          _focusVisible: {
            borderColor: '#8B5CF6',
            boxShadow: '0 0 0 1px #8B5CF6',
          },
        },
      },
    },
    Select: {
      baseStyle: {
        field: {
          bg: 'rgba(255,255,255,0.03)',
          borderColor: 'rgba(255,255,255,0.26)',
          color: 'white',
          borderRadius: '8px',
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          bg: '#1b1c2b',
          color: 'white',
          border: '1px solid rgba(255,255,255,0.16)',
          borderRadius: '10px',
        },
        header: {
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        },
      },
    },
    Link: {
      variants: {
        light_gray: {
          fontColor: 'light_dark',
          fontSize: ['12px', '13px', '14px'],
        },
      },
    },
    NavLink: {
      variants: {
        light_gray: {
          fontColor: 'light_dark',
          fontSize: ['12px', '13px', '14px'],
        },
      },
    },
    Text: {
      variants: {
        light_gray: {
          fontColor: 'light_dark',
          fontSize: ['12px', '13px', '14px'],
        },
      },
    },
    HStack: {
      variants: {
        menu_yellow_hover: {
          height: '100%',
          _hover: {
            borderBottom: '2px solid #FFBF00',
          },
        },
      },
    },
  },
  colors: {
    menu_gray: '#CCC3C2',
    main_dark: '#333',
    light_dark: '#666',
    main_yellow: '#FFBF00',
    main_red: '#FF0F00',
    main_purple: '#8B5CF6',
    panel_bg: '#10111d',
    panel_card: '#1b1c2b',
    panel_line: 'rgba(255,255,255,0.14)',
    menu_white: '#F8F8F8',
    date_gray: '#A9A9A9',
  },
});

export default theme;
